
import React from 'react';
import MasterLicenseLayout from '@/components/masterlicense/MasterLicenseLayout';
import { useMasterLicense } from '@/hooks/useMasterLicense';
import UserManagementTabs from '@/components/masterlicense/users/UserManagementTabs';

const MasterLicenseUserManagement = () => {
  const { handleLogout, isLoading, user } = useMasterLicense();

  return (
    <MasterLicenseLayout
      isLoading={isLoading}
      onLogout={handleLogout}
      userRole={user?.role}
      activeTab="users"
    >
      <div className="container mx-auto px-4 space-y-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">User Management</h1>
        </div>
        <UserManagementTabs />
      </div>
    </MasterLicenseLayout>
  );
};

export default MasterLicenseUserManagement;
